import { FC, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import styled from "styled-components";
import useObserver from "lib/hooks/kaleido/useObserver";
import Link from "next/link";

interface MerchandiseType {
  thumb: string;
  name: string;
  name2?: string;
  price: string;
  date: string;
  url?: string;
}

const merchandiseData: MerchandiseType[] = [
  {
    thumb: "/image/lp/kaleido/merchandise/thumb/01.jpg",
    name: "ねんどろいど 苗木野そら",
    name2: "　",
    price: "6,700円",
    date: "7月5日予約発売開始",
    url: "https://www.goodsmile.com/ja/product/36019/%E3%81%AD%E3%82%93%E3%81%A9%E3%82%8D%E3%81%84%E3%81%A9+%E8%8B%97%E6%9C%A8%E9%87%8E%E3%81%9D%E3%82%89",
  },
  {
    thumb: "/image/lp/kaleido/merchandise/thumb/02.jpg",
    name: "カレイドスター",
    name2: "LINEスタンプ",
    price: "250円",
    date: "好評発売中",
    url: "https://store.line.me/stickershop/product/25805906/ja",
  },
  {
    thumb: "/image/lp/kaleido/merchandise/thumb/03.jpg",
    name: "カレイドスターの",
    name2: "すごい資料集",
    price: "4,400円",
    date: "好評発売中(他にも商品あります)",
    url: "https://animestyle.jp/shop/archives/2898",
  },
];

const Merchandise: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = visibleSection === "merchandise" || sectionVisibilityFlags["merchandise"];

  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="merchandise">
      <AnchorTarget id="merchandise" />
      <Headline src={"/image/lp/kaleido/merchandise/head.png"} alt="グッズ" />
      <Content>
        <MerchandiseGrid>
          {merchandiseData.map((item, index) => (
            <MerchandiseItem key={index}>
              <ImageWrapper>
                {item.url ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <img src={item.thumb} alt={item.name} />
                  </a>
                ) : (
                  <img src={item.thumb} alt={item.name} />
                )}
              </ImageWrapper>
              <TextWrapper>
                <Name>{item.name}</Name>
                <Name>{item.name2}</Name>
                <Price>{item.price}</Price>
                <Date>
                  {item.date.includes("(他にも商品あります)") ? (
                    <>
                      {item.date.replace("(他にも商品あります)", "")}
                      <span className="small-text">(他にも商品あります)</span>
                    </>
                  ) : (
                    item.date
                  )}
                </Date>
              </TextWrapper>
            </MerchandiseItem>
          ))}
        </MerchandiseGrid>
      </Content>
      <BannerArea>
        <Link href="https://www.gonzo.co.jp/archives/kaleido-star/index.html">
          <BannerImage
            src={"/image/lp/kaleido/merchandise/banner.png"}
            alt="旧LPバナー"
          />
        </Link>
      </BannerArea>
    </StyledSection>
  );
};
export default Merchandise;

const StyledSection = styled(Section)`
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }

  @media screen and (max-width: 350px) {
    margin-top: 0px;
    margin-bottom: 10px;
  }
  @media screen and (min-width: 351px) {
    margin-top: 0px;
    margin-bottom: 10px;
  }
  @media screen and (min-width: 961px) {
    margin-top: 0px;
    margin-bottom: 40px;
  }
  @media screen and (min-width: 1281px) {
    margin-bottom: 10px;
  }
`;
const Content = styled.div`
  @media screen and (max-width: 500px) {
    padding: 0 8px;
  }
  @media screen and (min-width: 501px) {
    padding: 0 10px;
  }
`;
const MerchandiseGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 32px 0px;
  
  @media screen and (max-width: 960px) {
    padding: 0px;
  }
`;
const MerchandiseItem = styled.div`
  width: calc(33.333% - 10px);
  margin-bottom: 20px;
  text-align: right;
  background-color: white;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 860px) {
    padding: 1vw;
    width: calc(33.333% - 5px);
  }
`;
const ImageWrapper = styled.div`
  height: 350px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 860px) {
    height: 35vw;
  }
`;
const TextWrapper = styled.div`
  background-color: white;
  margin-top: 15px;

  @media screen and (max-width: 860px){
    padding: 10px 0px;
    margin-top: 1vw;
  }
`;
const Name = styled.div`
  font-size: 19px;
  margin-bottom: 10px;

  @media screen and (max-width: 860px){
    font-size: 2.1vw;
  }
`;
const Price = styled.div`
  font-size: 18px;
  margin-bottom: 10px;

  @media screen and (max-width: 860px){
  font-size: 2vw;
  }
`;
const Date = styled.div`
  font-size: 18px;
  
  @media screen and (max-width: 860px){
    font-size: 2vw;
  }

  span.small-text {
    font-size: 13px;

    @media screen and (max-width: 860px){
      font-size: 1.5vw;
    }
  }
`;

const BannerArea = styled.div`
  margin: 20px 20px 0;
  display: flex;
  @media screen and (max-width: 960px) {
    justify-content: center;
    flex-wrap: wrap;
  }
  @media screen and (min-width: 961px) {
    justify-content: center;
  }
`;
const BannerImage = styled.img`
  cursor: pointer;
  margin-right: 15px;
  margin-left: 15px;
  @media screen and (max-width: 310px) {
    margin-bottom: 10px;
    width: 280px;
  }
  @media screen and (min-width: 311px) {
    margin-bottom: 10px;
    width: 300px;
  }
  @media screen and (min-width: 961px) {
    width: 400px;
  }
`;
